import { Popup } from "components/popups/Popup";
import Button from "components/shared/button";
import Input, { InputType } from "components/shared/inputs/input";
import { useCallback, useEffect, useState } from "react";
// import { useDeleteEtudeDataMutation } from "store/api";
import useTranslation from "utils/hooks/useTranslation";
// import { getLocalStorageAccessToken } from "utils/helpers/localStorage";
// import { env } from "../../env";
import { message } from "antd";
import { useCreateEtudePDFMutation } from "store/api";
import Loader from "components/shared/loader";

export const PdfDownloadPopup: React.FC<{
  network: any;
  selectedRowIDs: any;
  isPdfURLLoading?: boolean;
  setIsPdfURLLoading?: (loading: boolean) => void;
  isEtudeDetail?: boolean;
}> = ({ network, selectedRowIDs, isEtudeDetail }) => {
  const { t, language } = useTranslation();
  const [showPrice, setShowPrice] = useState<boolean>(true);
  const [isPdfURLLoading, setIsPdfURLLoading] = useState<boolean>(false);
  const [createEtudePDF] = useCreateEtudePDFMutation();
  const [pdfUrl, setPdfUrl] = useState<string>("");
  
  useEffect(() => {
    onDownload();
  }, [])


  const onDownload = async (_showPrice: any = showPrice) => {
    try {
      // const newWindow = window.open("", "_blank");
      // if (newWindow) {
      //   newWindow.document.write(`
      //     <html>
      //       <head>
      //         <title>Loading...</title>
      //         <style>
      //           body {
      //             display: flex;
      //             align-items: center;
      //             justify-content: center;
      //             height: 100vh;
      //             font-family: Arial, sans-serif;
      //             background-color: #fafafa;
      //             color: #333;
      //           }
      //           .spinner {
      //             border: 4px solid #eee;
      //             border-top: 4px solid #3498db;
      //             border-radius: 50%;
      //             width: 40px;
      //             height: 40px;
      //             animation: spin 1s linear infinite;
      //             margin-right: 10px;
      //           }
      //           @keyframes spin {
      //             0% { transform: rotate(0deg); }
      //             100% { transform: rotate(360deg); }
      //           }
      //         </style>
      //       </head>
      //       <body>
      //         <div>
      //           <div class="spinner"></div>
      //           <div>Preparing your document...</div>
      //         </div>
      //       </body>
      //     </html>
      //   `);
      // }
      setIsPdfURLLoading?.(true);
      const pdfUrl = await createEtudePDF({
        etudeIds: JSON.stringify(selectedRowIDs),
        showPrice: _showPrice,
        isEtudeDetail: isEtudeDetail,
        culture: language!,
        networkId: network?.id,
      }).unwrap();

     
      setPdfUrl(pdfUrl)
      setIsPdfURLLoading?.(false);
    } catch (error) {
      setIsPdfURLLoading?.(false);
      message.error("Error opening PDF: Something went wrong");
      console.error("Error opening PDF:", error);
    }
  };

  const onOpen = useCallback(() => {
     const newWindow = window.open(new URL(pdfUrl).toString(), "_blank");
      if (newWindow) {
        newWindow.location.href = new URL(pdfUrl).toString();
        newWindow.focus();
      } else {
        message.error("Failed to open a new tab.");
      }
  }, [pdfUrl])


  const onChangeTarif = useCallback((e: any) => {

    setShowPrice(e.target.checked)
    onDownload(e.target.checked);
  }, []); 

  // const server_url = env.app_token_url || "";
  return (
    <Popup title={t("FO_DOC_NOTEDECALCUL")}>
      {({ onClose }) => {
        return (
          <group data-length="600">
                  {isPdfURLLoading && <Loader />}
            
            <group data-space="30" data-direction="column">
              <Input
                type={InputType.Checkbox}
                simple
                label={t("FO_DOC_PRICE")}
                name="showPrice"
                checked={showPrice}
                onChange={(e) => onChangeTarif(e)}
              />
            </group>
            <group
              data-space="30"
              data-gap="10"
              data-background="highlight"
              data-justify="end"
            >
              <Button
                outline
                large
                type="button"
                onClick={() => {
                  onClose?.();
                }}
              >
                <text>{t("cancel")}</text>
              </Button>
              {/* <form
                // action={server_url + "/api/showEtude"}
                action={pdfUrl}
                method="post"
                target={"_blank"}
              >
                <input
                  type="hidden"
                  name="user_token"
                  value={getLocalStorageAccessToken()?.toString()}
                />
                <input
                  type="hidden"
                  name="etudeIds"
                  value={JSON.stringify(selectedRowIDs)}
                />
                <input
                  type="hidden"
                  name="showPrice"
                  value={showPrice.toString()}
                />
                <input
                  type="hidden"
                  name="isEtudeDetail"
                  value={isEtudeDetail?.toString()}
                />
                <input type="hidden" name="networkId" value={network?.id} />
                <input type="hidden" name="culture" value={language!} />
              </form> */}
                <Button
                  // type="submit"
                  primary
                  large
                  autoFocus
                  onClick={() => {
                    onClose?.();
                    onOpen();
                  }}
                >
                  <text>{t("FO_DOC_UPLOAD")}</text>
                </Button>
            </group>
          </group>
        );
      }}
    </Popup>
  );
};
